// extracted by mini-css-extract-plugin
module.exports = {"postInspectionDiyPriceTab":"_1V8T8","campaignWrapper":"ce0Ia","video":"_3zqSr"};